import "./src/components/layout.css"
import "@reach/menu-button/styles.css"
import React, { useContext } from "react"
import { MDXProvider } from "@mdx-js/react"
import theme1 from "prism-react-renderer/themes/vsDark"
import theme2 from "prism-react-renderer/themes/duotoneDark"
import theme3 from "prism-react-renderer/themes/oceanicNext"
import Highlight, { defaultProps } from "prism-react-renderer"
import ThemeContextProvider from "./src/context/themeContext"

const LineNo = ({ children }) => (
  <span className="inline-block w-8 select-none text-gray-500">{children}</span>
)
const Pre = ({ children }) => (
  <span className="text-left my-4 p-2 leading-tight">{children}</span>
)
const components = {
  pre: props => {
    const className = props.children.props.className || ""
    const matches = className.match(/language-(?<lang>.*)/)

    return (
      <Highlight
        {...defaultProps}
        code={props.children.props.children.trim()}
        language={
          matches && matches.groups && matches.groups.lang
            ? matches.groups.lang
            : ""
        }
        theme={theme1}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre
            className={`${className} text-left my-4 p-2 leading-tight md:leading-normal tracking-normal md:tracking-wider w-full overflow-x-auto`}
            style={style}
          >
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line, key: i })}>
                <LineNo>{i + 1}</LineNo>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    )
  },
}

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeContextProvider>
      <MDXProvider components={components}>{element}</MDXProvider>
    </ThemeContextProvider>
  )
}
